import * as C from '../../../i18n/constants';
import { registerOperation } from '../logicalOperationRegisterer';
export var OPERATION_ID = 'conjunction';
export var SHORT_NAME_FOR_COMPONENT = C.FILTERS_LABELS_CONJUNCTION; // p AND q AND w AND x AND... === TRUE?

export function operationResult(conditions, value) {
  return conditions.every(function (condition) {
    return condition.func(value);
  });
}
registerOperation(OPERATION_ID, SHORT_NAME_FOR_COMPONENT, operationResult);


//////////////////
// WEBPACK FOOTER
// ./~/handsontable/es/plugins/filters/logicalOperations/conjunction.js
// module id = 3OFf
// module chunks = 0